module.exports = __webpack_public_path__ + "static/media/hat-chef.c91c93c8.svg";